import UserIcon from "@material-ui/icons/Group";
import {
  UserMenu,
  MenuItemLink,
  AppBar,
  Layout,
  getResources,
  Menu,
  useAuthState,
} from "react-admin";
import DefaultIcon from "@material-ui/icons/ViewList";
import { useSelector } from "react-redux";
import { ProfileProvider } from "../pages/ProfileEdit";
import SettingsIcon from "@material-ui/icons/Settings";

const MyUserMenu = (props: any) => {
  // Forcing MenuItemLink to any because of some weird type mismatch, not sure what's going on
  const ItemLink = MenuItemLink as any;
  return (
    <UserMenu {...props}>
      <ItemLink
        to="/my-profile"
        primaryText="My Profile"
        leftIcon={<SettingsIcon />}
      />
    </UserMenu>
  );
};

export const MyMenu = (props: any) => {
  const ItemLink = MenuItemLink as any;
  const resources = useSelector(getResources).filter(
    (resource) => resource.name !== "dummy"
  );
  const { authenticated } = useAuthState();
  return (
    <Menu {...props}>
      {authenticated === false ? (
        <ItemLink
          to="/login"
          primaryText={"Login"}
          key="login"
          leftIcon={<UserIcon />}
        />
      ) : null}
      {authenticated === true &&
        resources.map((resource: any) => (
          <ItemLink
            key={resource.name}
            to={`/${resource.name}`}
            primaryText={
              (resource.options && resource.options.label) || resource.name
            }
            leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
            onClick={props.onMenuClick}
          />
        ))}

      {/* add your custom menus here */}
    </Menu>
  );
};
const MyAppBar = (props: any) => (
  <AppBar {...props} userMenu={<MyUserMenu />} />
);

const MyLayout = (props: any) => (
  <ProfileProvider>
    <Layout {...props} appBar={MyAppBar} menu={MyMenu} />
  </ProfileProvider>
);

export default MyLayout;
